import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Dialog as RACDialog } from 'react-aria-components';
import { twMerge } from '../../utils/twMerge.js';
/**
 * A dialog is an overlay shown above other content in an application.
 *
 * @example
 * ```tsx
 * <DialogModal>
 *   <Dialog>
 *     <DialogHeader>
 *       <DialogTitle>This is a modal dialog</DialogTitle>
 *       <OverlayCloseButton label="Close" />
 *     </DialogHeader>
 *     <DialogBody>
 *       <Text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text>
 *     </DialogBody>
 *   </Dialog>
 * </DialogModal>
 * ```
 */
export const Dialog = forwardRef(function Dialog(props, forwardedRef) {
    return (_jsx(RACDialog, { ...props, ref: forwardedRef, className: twMerge('ppl-Dialog flex max-h-[90vh] flex-col bg-default outline-none', props.className) }));
});
//# sourceMappingURL=Dialog.js.map